import { debugConsole } from "./debugConsole";

export const removeEmptyValueFromObject = (obj: Record<string, any> = {}) => {
  debugConsole("🚀 ~ removeEmptyValueFromObject ~ obj:", obj);
  Object.keys(obj).forEach((key) => {
    if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
      delete obj[key];
    }
  });
  return obj;
};

/**
 * Recursively removes all keys with null or undefined values from an object
 * @param obj - The object to clean
 * @returns A new object with null/undefined keys removed
 */
export function removeNullUndefinedKeys<T = any>(obj: T): T {
  if (obj === null || obj === undefined) {
    return obj;
  }

  // Handle arrays
  if (Array.isArray(obj)) {
    return obj.map((item) => removeNullUndefinedKeys(item)) as T;
  }

  // Handle objects
  if (typeof obj === "object") {
    const cleaned: any = {};

    for (const [key, value] of Object.entries(obj)) {
      // Skip null and undefined values
      if (value !== null && value !== undefined) {
        // Recursively clean nested objects and arrays
        cleaned[key] = removeNullUndefinedKeys(value);
      }
    }

    return cleaned as T;
  }

  // Return primitive values as-is
  return obj;
}

/**
 * Alternative function name for better readability
 */
export const cleanObject = removeNullUndefinedKeys;

/**
 * Utility function to check if an object is empty after cleaning
 * @param obj - The object to check
 * @returns boolean indicating if the object is empty
 */
export function isEmptyAfterCleaning(obj: any): boolean {
  const cleaned = removeNullUndefinedKeys(obj);
  return Object.keys(cleaned).length === 0;
}
